/**
 * Overview: the one tab every Unified Profile has.
 *
 * Guaranteed by the frontend rather than trusted from the endpoint. That is not
 * a hardcoded tab LIST — the list is data — it is the screen's single
 * invariant, and holding it here is what keeps a profile usable when the tabs
 * request fails, and what makes `/overview` a stable URL to link to.
 */
export const OVERVIEW_TAB = Object.freeze({
  id: 'overview',
  labelKey: 'profile.tabs.overview',
  kind: 'DASHBOARD',
  module: 'OVERVIEW',
});

/**
 * Renderer kinds the frontend knows today. Anything else degrades.
 *
 * Overview is the only DASHBOARD, and the frontend owns that tab. A dynamic tab
 * is a LIST — data with filters and search — rendered by one component with no
 * per-tab code. ACTIVITY (CT-5527) is the one designed feed: the tabs endpoint
 * decides which entity types get it, exactly as it decides which get a LIST,
 * so nothing here is keyed by entity type. INTELLIGENCE (CT-5715) is the same:
 * a designed tab with subtabs (Traits, Insights) as child routes. TASKS
 * (CT-5722) is the record's to-do list; KNOWLEDGE (CT-5717) its drive,
 * Sandbox and Truth, as child routes.
 */
export const TAB_KINDS = Object.freeze({
  DASHBOARD: 'DASHBOARD',
  LIST: 'LIST',
  ACTIVITY: 'ACTIVITY',
  INTELLIGENCE: 'INTELLIGENCE',
  TASKS: 'TASKS',
  KNOWLEDGE: 'KNOWLEDGE',
});

/**
 * The chips of the History Timeline, in order (CT-5527; Tasks added by CT-5724
 * as the prototype shows them). Events are still out. Which filters each chip
 * offers is NOT here: those come down with the rows.
 */
export const ACTIVITY_QUICK_FILTERS = Object.freeze(['all', 'communications', 'notes', 'tasks']);

export const DEFAULT_ACTIVITY_QUICK_FILTER = 'all';

/** The feed is newest-first; this is also where "Clear all" returns the sort to. */
export const ACTIVITY_SORT_FIELD = 'occurred_at';
export const ACTIVITY_SORT_DIRECTION = 'desc';

/**
 * What a search over the feed covers: subject, body preview and AI summary — not
 * `description`, which the generic list uses and the feed has no field for.
 */
export const ACTIVITY_SEARCH_FIELDS = Object.freeze(['title', 'preview', 'ai_summary']);
